<div class="payment payment-feedback payment-feedback--{{ feedbackType }}" *ngIf="pageContext">
  <header class="modal__header">
    <h2>{{ "payment.receipt.label.your_order" | translate }}</h2>
    <a class="button button--transparent modal__button--close" (click)="closeModal(true)"><i class="icon icon-ui-close--sm"></i></a>
  </header>
  <div class="modal__content">
    <form class="form">
      <div class="form-block form-block__border">
        <div class="form-group payment__cta">
          <ng-container [ngSwitch]="feedbackType">
            <ng-container
              *ngSwitchCase="paymentFeedbackType.failed"
              [ngTemplateOutlet]="failed"
              [ngTemplateOutletContext]="{ $implicit: feedbackFailed }"
            ></ng-container>
            <ng-container
              *ngSwitchCase="paymentFeedbackType.failedPayment"
              [ngTemplateOutlet]="failedPayment"
              [ngTemplateOutletContext]="{ $implicit: feedbackFailedPayment }"
            ></ng-container>
            <ng-container
              *ngSwitchCase="paymentFeedbackType.failedPaymentDeepLink"
              [ngTemplateOutlet]="failedPaymentDeepLink"
              [ngTemplateOutletContext]="{ $implicit: feedbackFailedPaymentDeepLink }"
            ></ng-container>
            <ng-container
              *ngSwitchCase="paymentFeedbackType.failedFunds"
              [ngTemplateOutlet]="failedFunds"
              [ngTemplateOutletContext]="{ $implicit: feedbackFailedFunds }"
            ></ng-container>
            <ng-container
              *ngSwitchCase="paymentFeedbackType.failedAccount"
              [ngTemplateOutlet]="failedAccount"
              [ngTemplateOutletContext]="{ $implicit: feedbackFailedAccount }"
            ></ng-container>
            <ng-container
              *ngSwitchCase="paymentFeedbackType.success"
              [ngTemplateOutlet]="success"
              [ngTemplateOutletContext]="{ $implicit: feedbackSuccess }"
            ></ng-container>
          </ng-container>
        </div>
      </div>
    </form>
  </div>
</div>

<ng-template #success let-feedbackTexts>
  <div class="form-group">
    <h3 class="h3--sm">{{ successText?.title || feedbackSuccess?.title }}</h3>
    <i class="icon icon-ui-checkmark--sm"></i>
  </div>
  <div class="payment-feedback__body" [internalInnerHtml]="successText?.body || feedbackSuccess?.body"></div>
  <a class="button button--cta button--full" (click)="onButtonClick($event)">
    <span>{{ "general.label.close" | translate }}</span>
  </a>
</ng-template>

<ng-template #failed let-feedbackTexts>
  <div class="form-group">
    <h3 class="h3--sm">{{ failedText?.title || feedbackFailed?.title }}</h3>
    <i class="icon icon-ui-alert"></i>
  </div>
  <div class="payment-feedback__body" [internalInnerHtml]="failedText?.body || feedbackFailed?.body"></div>
  <a class="button button--cta button--full" (click)="onButtonClick($event)">
    <span>{{ "general.label.close" | translate }}</span>
  </a>
</ng-template>

<ng-template #failedPayment let-feedbackTexts>
  <div class="form-group">
    <h3 class="h3--sm">{{ failedPaymentText?.title || feedbackFailedPayment?.title }}</h3>
    <i class="icon icon-ui-alert"></i>
  </div>
  <div class="payment-feedback__body" [internalInnerHtml]="failedPaymentText?.body || feedbackFailedPayment?.body"></div>
  <a class="button button--cta button--full" (click)="onButtonClick($event)">
    <span>{{ "payment.feedback.label.retry" | translate }}</span>
  </a>
</ng-template>

<ng-template #failedPaymentDeepLink let-feedbackTexts>
  <div class="form-group">
    <h3 class="h3--sm">{{ feedbackFailedPaymentDeepLink?.title }}</h3>
    <i class="icon icon-ui-alert"></i>
  </div>
  <div class="payment-feedback__body" [internalInnerHtml]="feedbackFailedPaymentDeepLink?.body"></div>
  <a class="button button--cta button--full" (click)="onButtonClick($event)">
    <span>{{ "payment.feedback.label.retry" | translate }}</span>
  </a>
</ng-template>

<ng-template #failedFunds let-feedbackTexts>
  <div class="form-group">
    <h3 class="h3--sm">{{ feedbackFailedFunds?.title }}</h3>
    <i class="icon icon-ui-alert"></i>
  </div>
  <div class="payment-feedback__body" [internalInnerHtml]="feedbackFailedFunds?.body"></div>
  <a class="button button--cta button--full" (click)="onButtonClick($event)">
    <span>{{ "general.label.close" | translate }}</span>
  </a>
</ng-template>

<ng-template #failedAccount let-feedbackTexts>
  <div class="form-group">
    <h3 class="h3--sm">{{ feedbackFailedAccount?.title }}</h3>
    <i class="icon icon-ui-alert"></i>
  </div>
  <div class="payment-feedback__body" [internalInnerHtml]="feedbackFailedAccount?.body"></div>
  <a class="button button--cta button--full" (click)="onButtonClick($event)">
    <span>{{ "general.label.close" | translate }}</span>
  </a>
</ng-template>
